import './common'
import '../scss/style.scss';

import '~components/slider/slider'
